import styled from 'styled-components';

import { BlueButton } from '../BlueTheme';

export const Content = styled.div`
  padding: ${({ theme }): string => theme.spacers!.spacer06};
  background: ${({ theme }): string => theme.colors!.colorWhite};
  border-radius: ${({ theme }): string => theme.spacers!.spacer04};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  min-height: 300px;
`;

export const Container = styled.div`
  flex-basis: 100%;
`;

export const ButtonWrapper = styled(BlueButton)`
  height: 48px;
`;

export const TitleWrapper = styled.p`
  font-size: 32px;
  font-weight: 600;
`;
